
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh-Hans",
  "zh-Hant",
  "fr",
  "de",
  "it",
  "ja",
  "ko",
  "pt-BR",
  "ru",
  "es"
]

export const localeLoaders = {
  en: [],
  "zh-Hans": [],
  "zh-Hant": [],
  fr: [],
  de: [],
  it: [],
  ja: [],
  ko: [],
  "pt-BR": [],
  ru: [],
  es: []
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      label: "English",
      files: []
    },
    {
      code: "zh-Hans",
      language: "zh-CN",
      label: "简体中文",
      files: []
    },
    {
      code: "zh-Hant",
      language: "zh-TW",
      label: "繁體中文",
      files: []
    },
    {
      code: "fr",
      language: "fr-FR",
      label: "Français",
      files: []
    },
    {
      code: "de",
      language: "de-DE",
      label: "Deutsch",
      files: []
    },
    {
      code: "it",
      language: "it-IT",
      label: "Italiano",
      files: []
    },
    {
      code: "ja",
      language: "ja-JP",
      label: "日本語",
      files: []
    },
    {
      code: "ko",
      language: "ko-KR",
      label: "한국어",
      files: []
    },
    {
      code: "pt-BR",
      language: "pt-BR",
      label: "Português",
      files: []
    },
    {
      code: "ru",
      language: "ru-RU",
      label: "Русский",
      files: []
    },
    {
      code: "es",
      language: "es-ES",
      label: "Español",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    label: "English",
    files: []
  },
  {
    code: "zh-Hans",
    language: "zh-CN",
    label: "简体中文",
    files: []
  },
  {
    code: "zh-Hant",
    language: "zh-TW",
    label: "繁體中文",
    files: []
  },
  {
    code: "fr",
    language: "fr-FR",
    label: "Français",
    files: []
  },
  {
    code: "de",
    language: "de-DE",
    label: "Deutsch",
    files: []
  },
  {
    code: "it",
    language: "it-IT",
    label: "Italiano",
    files: []
  },
  {
    code: "ja",
    language: "ja-JP",
    label: "日本語",
    files: []
  },
  {
    code: "ko",
    language: "ko-KR",
    label: "한국어",
    files: []
  },
  {
    code: "pt-BR",
    language: "pt-BR",
    label: "Português",
    files: []
  },
  {
    code: "ru",
    language: "ru-RU",
    label: "Русский",
    files: []
  },
  {
    code: "es",
    language: "es-ES",
    label: "Español",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/